import React from "react";

const ErrorText = ({ text }) => {
  return <div style={{ color: "red", fontSize: "14px" }}>{text}</div>;
};

export default ErrorText;
